<template lang="pug">
div
	v-row(no-gutters)
		v-col.grow
			.title notificaties
		v-col.shrink
			v-btn(text @click="markAllAsRead")
				v-icon(left) done_all
				| {{$t('notification-box.mark-all-read')}}
	v-card(color="info" outlined)
		v-card-text.py-2
			v-row(v-for="notification in groupedNotifications()" :key="notification.id" dense)
				v-col.shrink
					v-icon(small color="accent") {{{mention: 'record_voice_over', 'favorite': 'forum', inbox: 'inbox'}[notification.type]}}
				v-col.grow
					p.accent--text.ma-0
						i18n(:path="`notification-box.message-${notification.type}`")
							nuxt-link(slot="link" @click.native="markAsRead(notification.ids)" :to="notification.url") {{notification.title}}
						|
						|
						small(v-if="notification.count > 1") ({{notification.count}})
				v-col.shrink
					v-btn(text icon x-small @click="markAsRead(notification.ids)")
						v-icon done
</template>

<script>
import groupBy from 'lodash/groupBy';

export default {
	props: {
		notifications: {
			type: Array,
			required: true
		}
	},
	methods: {
		markAsRead(ids) {
			this.$store.dispatch('markNotificationAsRead', ids);
		},
		markAllAsRead() {
			this.$store.dispatch(
				'markNotificationAsRead',
				this.notifications.map(e => e.id)
			);
		},
		groupedNotifications() {
			const grouped = groupBy(
				this.notifications,
				notification => notification.url.split('?')[0] + '_' + notification.type
			);
			const groupedResult = [];
			Object.entries(grouped).forEach(([_key, value]) => {
				groupedResult.push({
					...value[0],
					count: value.length,
					ids: value.map(v => {
						return v.id;
					})
				});
			});
			return groupedResult;
		}
	}
};
</script>
